<template>
    <div class="view view--videos">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            v-html="__('+ Add video')"
            v-on:click="showAddModal"
        ></btn>

        <add-modal
            v-bind:errors="errors"
            v-bind:is-open="isOpenAddModal"
            v-on:close="isOpenAddModal = false"
            v-on:create="createVideo"
        ></add-modal>

        <edit-modal
            v-bind:errors="errors"
            v-bind:is-open="isOpenEditModal"
            v-bind:video="editedVideo"
            v-on:close="isOpenEditModal = false"
            v-on:update="updateVideo"
        ></edit-modal>

        <delete-modal
            v-bind:open="isOpenDeleteModal"
            v-bind:video-id="deletingId"
            v-on:close="isOpenDeleteModal = false"
            v-on:delete="deleteVideo"
        ></delete-modal>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import VideoRepository from '../../repositories/VideoRepository';
import AddModal from './components/AddModal';
import EditModal from './components/EditModal';
import DeleteModal from './components/DeleteModal';

export default {
    components: {
        DeleteModal,
        EditModal,
        AddModal,
        Btn,
        Control,
        DataTable,
        Modal
    },
    created: function() {
        this.videoRepository = new VideoRepository();
    },
    data: function() {
        return {
            deletingId: null,
            editedVideo: {
                id: null,
                file: null,
                title: '',
                video: ''
            },
            errors: {},
            isOpenAddModal: false,
            isOpenDeleteModal: false,
            isOpenEditModal: false,
            tableData: {
                columnNames: {
                    title: this.__('Title'),
                    video: this.__('Video')
                },
                items: [],
                sortableColumns: ['title']
            },
            videoRepository: null,
            videos: []
        };
    },
    methods: {
        createVideo: async function(addedVideo) {
            try {
                const data = {
                    orientation: addedVideo.orientation,
                    title: addedVideo.title,
                    video: addedVideo.file,
                    videoName: addedVideo.name
                };

                await this.videoRepository.createVideo(data);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Video was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getVideos();

                this.isOpenAddModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        deleteVideo: async function(videoId) {
            try {
                await this.videoRepository.deleteVideo(videoId);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Video was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getVideos();
            } catch (error) {
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getVideos: async function(sort = '') {
            try {
                this.videos = await this.videoRepository.getVideos(sort);

                let items = [];
                this.videos.forEach(video => {
                    items.push(this.transformVideoData(video));
                });
                this.$set(this.tableData, 'items', items);
            } catch (error) {}
        },
        showAddModal: function() {
            this.errors = {};
            this.isOpenAddModal = true;
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        showEditModal: function(data) {
            this.editedVideo = {
                id: data.id,
                file: null,
                title: data.title,
                video: data.url,
                orientation: data.orientation
            };

            this.errors = {};

            this.isOpenEditModal = true;
        },
        transformVideoData: function(video) {
            let actions = [];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                method: 'showEditModal',
                title: this.__('Edit')
            });

            return {
                values: {
                    id: video.id,
                    title: video.title,
                    url: video.video,
                    video:
                        '<video controls width="200"><source src="' +
                        video.video +
                        '"></video>',
                    orientation: video.orientation
                },
                actions: actions
            };
        },
        sortDataTable: function(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getVideos(sortByColumn);
            }
        },
        updateVideo: async function(editedVideo) {
            try {
                const data = {
                    title: editedVideo.title,
                    video: editedVideo.file,
                    videoName: editedVideo.name,
                    orientation: editedVideo.orientation
                };

                await this.videoRepository.updateVideo(
                    this.editedVideo.id,
                    data
                );

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Video was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getVideos();

                this.isOpenEditModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        }
    },
    mounted: function() {
        this.getVideos();
    }
};
</script>
